import { checkStore } from './checkers'
import { registerEntities } from '../actions'

/**
 * creates injectEntities helper for provided store
 *
 * @param {Object} store - redux store
 * @param {Boolean} isValid - is store validated before to not check again
 * @return {Function} injectEntities helper
 */
export function injectEntitiesFactory(store, isValid) {
  /**
   * inject reducer on given store
   *
   * @param {String} key - store.injectedReducer key to identify
   * @param {Array<String>} [entities=[]] - entities names to register
   * @throws {InvariantError} if store is invalid
   */
  return (entities = []) => {
    if (!isValid) checkStore(store)

    // TODO: only inject entities first time
    if (entities.length > 0) {
      store.dispatch(registerEntities(entities))
    }
  }
}

/**
 * create the injectEntities method for the given store
 *
 * @param {Object} store - redux store
 * @return {{ injectEntities: Function }} reducer injectors
 * @throws {InvariantError} if store is invalid
 */
export default function getInjectors(store) {
  checkStore(store)

  return {
    injectEntities: injectEntitiesFactory(store, true)
  }
}
